import { render } from "./ReviewsTab.vue?vue&type=template&id=5ba8ba9f&scoped=true"
import script from "./ReviewsTab.vue?vue&type=script&lang=js"
export * from "./ReviewsTab.vue?vue&type=script&lang=js"

import "./ReviewsTab.vue?vue&type=style&index=0&id=5ba8ba9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba8ba9f"]])

export default __exports__